import React, { ReactElement } from 'react'
import EasySetLogo from 'src/assets/logo-easyset-dark.svg?react'
import SchulthessLogo from 'src/assets/logo-schulthess-blue-black.svg?react'
import ServiceMasterLogo from 'src/assets/logo-servicemaster-dark.svg?react'
import WashMasterLogo from 'src/assets/logo-washmaster-dark-no-padding.svg?react'
import { Box, Stack, styled } from '@mui/material'
import { AppId } from 'src/app/AppId'
import { NoAccessToOrganizationText } from 'src/ui/layout-page/landing/NoAccessToOrganizationText'

const WashMasterLogoSmall = styled(WashMasterLogo)(({ theme }) => ({
  marginTop: theme.spacing(2),
  width: '400px',
  [theme.breakpoints.up('md')]: {
    width: '550px',
  },
}))

const ServiceMasterLogoSmall = styled(ServiceMasterLogo)(({ theme }) => ({
  width: '400px',
  [theme.breakpoints.up('md')]: {
    width: '550px',
  },
}))

const EasySetLogoSmall = styled(EasySetLogo)(({ theme }) => ({
  width: '400px',
  [theme.breakpoints.up('md')]: {
    width: '550px',
  },
}))

interface Props {
  app: AppId
}

export const LandingPage = ({ app = AppId.WASH_MASTER }: Props): ReactElement => {
  return (
    <Box>
      <Stack
        direction="column"
        spacing={3}
        sx={{
          justifyContent: 'center',
          width: '80%',
          margin: '0 auto',
          paddingTop: 3,
        }}
      >
        <Box
          sx={{
            alignSelf: 'center',
          }}
        >
          {app === AppId.WASH_MASTER && <WashMasterLogoSmall />}
          {app === AppId.SERVICE_MASTER && <ServiceMasterLogoSmall />}
          {app === AppId.EASY_SET && <EasySetLogoSmall />}
        </Box>
        <NoAccessToOrganizationText />
        <Box
          sx={{
            width: '250px',
            alignSelf: 'center',
            paddingTop: 2,
          }}
        >
          <SchulthessLogo />
        </Box>
      </Stack>
    </Box>
  )
}
